const OciPagination = require('./OciPagination')
const OciProduct = require('./OciProduct')

class OciBackgroundSearchCatalog {

    /**
     * @private
     * @property {(catalogId: string, query: string) => Promise<{
     *     total: number;
     *     offset: number;
     *     limit: number;
     *     members: OciProduct[];
     * }>} search - search for catalog data
     */
    dataService;

    /**
     * @type {string}
     */
    id;

    /**
     * @type {string}
     */
    name;

    /**
     * @type {OciProduct[]}
     */
    products;

    /**
     * @type {OciPagination}
     */
    pagination;

    /**
     * Indicates if the catalog is currently searching for products
     * @type {boolean}
     */
    loading = false;

    /**
     * Sometimes the oci background search can run into a timeout if the supplier has potato servers.
     * In this case we want to display an failure notification
     * @type {boolean}
     */
    searchTimeout = false;

    /**
     * If the search request returns a non 408 error status code we indicate it with this flag.
     * @type {boolean}
     */
    error = false;

    constructor(ociBackgroundSearchService, catalog) {
        this.dataService = ociBackgroundSearchService;
        this.id = catalog.catalogId;
        this.name = catalog.name;
    }

    /**
     * Search for products within this catalog
     * @param query {string}
     */
    searchFor(query) {
        this.loading = true;
        this.dataService.search(this.id, query).then(result => {
            this.pagination = new OciPagination(result.total, result.offset, result.limit);
            if(result.members) {
                this.products = result.members.map(product => new OciProduct(product));
            }
        }).catch((error) => {
            console.error(error);

            // HTTP Status 408 = REQUEST_TIMEOUT
            if(error && error.status === 408) {
                this.searchTimeout = true;
            } else {
                this.error = true;
            }
        }).finally(() => this.loading = false)
    }

    /**
     * @returns {boolean} - true if any product has a image link attachment
     */
    get hasAnyProductImage() {
        if(this.products?.length) {
            return this.products.some(product => !!product.attachment);
        }

        return false;
    }

    /**
     * @returns {boolean} - true if any product has a image link attachment
     */
    get hasAnyUnits() {
        if(this.products?.length) {
            return this.products.some(product => product.hasUnits);
        }

        return false;
    }
}

module.exports = OciBackgroundSearchCatalog;